import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";
import { formatByIdSaga } from "src/store/helpers/formatByIdSaga";
import { toast } from "react-toastify";

const ACCOUNT_URL = "/services/rcp/profile/account/";
export function* changePassword() {
  yield takeLatest(CONSTANTS.GET_MAIN_CHANGE_PASSWORD, function* (action) {
    try {
      yield put(actions.setChangePassword(null));

      const url = ACCOUNT_URL + "changepassword";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      const message = yield formatByIdSaga("notifications.passwordChanged");
      toast.success(message);

      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setChangePassword(true));
    } catch (e) {
      if (e?.response.data.status === 400) {
        const errors = e?.response?.data?.errors?.NewPassword;
        console.log(errors);
        yield put(
          actions.setChangePassword({
            success: false,
            exceptionCode: e?.response?.data?.errors?.NewPassword || null,
          })
        );
      } else {
        yield put(actions.setChangePassword(e?.response?.data));
      }

      console.error(e);
    }
  });
}
export function* getPersonalInfo() {
  yield takeLatest(CONSTANTS.GET_MAIN_PERSONALINFO, function* () {
    try {
      yield put(actions.setPersonalInfo({}));

      const url = ACCOUNT_URL + "myprofile";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const data = res.data;

      yield put(actions.setPersonalInfo(data));
    } catch (e) {
      yield put(actions.setPersonalInfo({}));
      console.error(e);
    }
  });
}
export default function* accountSaga() {
  yield all([fork(changePassword), fork(getPersonalInfo)]);
}
